import React from "react";
import person1 from "assets/images/person_1.png";
import person2 from "assets/images/person_2.png";
import person3 from "assets/images/person_3.png";
import person4 from "assets/images/person_4.png";
import ReviewCardMobileSlider from "components/Slider/ReviewCardMobileSlider";
import { useMediaQuery } from "react-responsive";

const reviews = [
  {
    id: 1,
    content: (
      <div className="review-card">
        <img
          className="w-[48px] md:w-[59px] h-[48px] md:h-[59px] rounded-[36px] object-cover"
          src={person2}
          alt="avatar"
        />
        <div>
          <p className="leading-[28px] line-clamp-[8] font-normal text-[14px] text-black">
            HouseScan ha completamente cambiato il mio modo di cercare casa.
            Grazie alle{" "}
            <span className="font-semibold">liste condivisibili</span> e agli{" "}
            <span className="font-semibold">alert di prezzo,</span> ho sempre
            tutto sotto controllo. Inoltre, le{" "}
            <span className="font-semibold">analisi di mercato</span> sono
            davvero approfondite. Consigliatissimo per chi vuole fare un
            investimento immobiliare sicuro!
          </p>
          <h4 className="leading-[28px] font-normal text-[16px] text-black mt-2">
            Giovanni Marini
          </h4>
        </div>
      </div>
    ),
  },
  {
    id: 2,
    content: (
      <div className="review-card">
        <img
          className="w-[48px] md:w-[59px] h-[48px] md:h-[59px] rounded-[36px] object-cover"
          src={person3}
          alt="avatar"
        />
        <div>
          <p className="leading-[28px] line-clamp-[8] font-normal text-[14px] text-black">
            Fantastico!
            <span className="font-semibold"> L'estensione </span>
            per il browser mi permette di
            <span className="font-semibold"> aggregare annunci </span>da
            molteplici piattaforme, risparmiando tempo prezioso. HouseScan è
            diventato uno strumento indispensabile nelle mie ricerche
            immobiliari. Non potrei più farne a meno!
          </p>
          <h4 className="leading-[28px] font-normal text-[16px] text-black mt-2">
            Elisa Venturi
          </h4>
        </div>
      </div>
    ),
  },
  {
    id: 3,
    content: (
      <div className="review-card">
        <img
          className="w-[48px] md:w-[59px] h-[48px] md:h-[59px] rounded-[36px] object-cover"
          src={person1}
          alt="avatar"
        />
        <div>
          <p className="leading-[24px] line-clamp-[8] lg:leading-[28px] font-normal text-[14px] text-black">
            La piattaforma HouseScan ha rivoluzionato il mio approccio alla
            ricerca di immobili. Le
            <span className="font-semibold"> notifiche </span>
            per le variazioni di prezzo mi tengono sempre aggiornata, e le
            <span className="font-semibold"> analisi avanzate </span> sono
            incredibilmente utili. Altamente raccomandato a chiunque voglia
            avere il controllo completo sulla propria ricerca immobiliare.
          </p>
          <h4 className="leading-[28px] font-normal text-[16px] text-black mt-2">
            Marco Taddei
          </h4>
        </div>
      </div>
    ),
  },
  {
    id: 4,
    content: (
      <div className="review-card">
        <img
          className="w-[48px] md:w-[59px] h-[48px] md:h-[59px] rounded-[36px] object-cover"
          src={person4}
          alt="avatar"
        />
        <div>
          <p className="leading-[28px] line-clamp-[8] font-normal text-[14px] text-black">
            Uso HouseScan da alcuni mesi e sono impressionato dalla qualità
            delle<span className="font-semibold"> analisi </span>
            offerte. Le funzioni di
            <span className="font-semibold">
              {" "}
              organizzazione e sincronizzazione{" "}
            </span>
            degli annunci mi hanno aiutato a trovare la casa dei miei sogni. È
            lo strumento perfetto per chi cerca efficienza e dettaglio.
          </p>
          <h4 className="leading-[28px] font-normal text-[16px] text-black mt-2">
            Luisa Bianchi
          </h4>
        </div>
      </div>
    ),
  },
];

const WhatTheySayAboutUsSection = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  return (
    <div className="md:px-5 bg-[#f5f5f5] md:pt-[25px] md:pb-[56px] py-10">
      <div className="max-w-[1344px] mx-auto">
        <h1 className="font-bold text-[28px] lg:text-[36px] text-center leading-[1.3] md:leading-[34px] lg:leading-[43.57px] text-black">
          Cosa dicono di noi
        </h1>
        <div className="mt-5 lg:mt-[43px]  md:mb-0 mb-10">
          {isMobile ? (
            <ReviewCardMobileSlider>
              {reviews.map(({ id, content }) => (
                <div className="mr-[25px] px-[20px]" key={id}>
                  {content}
                </div>
              ))}
            </ReviewCardMobileSlider>
          ) : (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-[37px] ">
              {reviews.map(({ id, content }) => (
                <div
                  key={id}
                  className="review-card-shadow transition-all duration-300 "
                >
                  {content}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WhatTheySayAboutUsSection;
